import axios from 'axios';

import config from '@/config/config';
import { headers } from './auth.headers';
import { formatQueryString } from '@/helpers/query-string';
import { IDocumentType } from '@/domain/document-type.model';
import { IPaginateVueTable } from '@/interfaces/IPaginateVueTable';

const url_api_base = config.url_api_base;

export const insert = (data: IDocumentType): Promise<IDocumentType> => {
  return axios.post(`${url_api_base}/document-type`, data, headers());
};

export const update = (data: IDocumentType): Promise<IDocumentType> => {
  return axios.patch(`${url_api_base}/document-type/${data.id}`, data, headers());
};

export const get = (id: string): Promise<IDocumentType> => {
  const url = `${url_api_base}/document-type/${id}`;

  return axios.get(url, headers()).then((res) => res?.data);
};

export const list = (
  offset?: number,
  limit?: number,
  order?: string,
  sort?: string,
  filter?: string,
): Promise<IPaginateVueTable<IDocumentType>> => {
  const query = formatQueryString(offset, limit, order, sort, filter);
  const url = `${url_api_base}/document-type${query}`;

  return axios.get(url, headers()).then((res) => res?.data);
};

export const listActive = (): Promise<IDocumentType[]> => {
  const url = `${url_api_base}/document-type/list-active`;

  return axios.get(url, headers()).then((res) => res?.data);
};
